import SpaceBetween from "@awsui/components-react/space-between";
import React, {useState} from "react";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import Box from "@awsui/components-react/box";
import Link from "@awsui/components-react/link";
import League from "model/League";
import LeaguesSelect from "components/LeaguesSelect";
import UsersSelect from "components/UsersSelect";
import User from "model/User";
import AddPenaltyButton from "pages/admin/pages/add_penalty/components/AddPenaltyButton";
import SubmitFlashbar from "components/SubmitFlashbar";
import CompetitionsSelect from "components/CompetitionsSelect";
import Competition from "model/Competition";
import Textarea from "@awsui/components-react/textarea";


const AddPenaltyPage: React.FC = () => {

    const [selectedCompetition, setSelectedCompetition] = useState<Competition>();
    const [selectedLeague, setSelectedLeague] = useState<League>();
    const [selectedUser, setSelectedUser] = useState<User>();
    const [penaltyPoints, setPenaltyPoints] = useState<number>(0);
    const [submitMessage, setSubmitMessage] = useState<FlashbarProps.MessageDefinition>();


    return (
        <SpaceBetween size="l">
            <NavigationBar/>
            <Container
                header={
                    <Box variant={"span"}>
                        <Header variant="h1">Add penalty</Header>
                        <Link variant={"info"} href={"/admin"}>Back</Link>
                    </Box>
                }
            >
                <SpaceBetween size={"m"}>
                    {submitMessage && (
                        <SubmitFlashbar
                            submitMessage={submitMessage}
                            setSubmitMessage={setSubmitMessage}
                        />
                    )}
                    <LeaguesSelect
                        selectedLeague={selectedLeague}
                        setSelectedLeague={setSelectedLeague}
                    />
                    {selectedLeague && (
                        <UsersSelect
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                            leagueId={selectedLeague?.leagueId}
                        />
                    )}
                    {selectedLeague && selectedUser && (
                        <CompetitionsSelect
                            selectedCompetition={selectedCompetition}
                            setSelectedCompetition={setSelectedCompetition}
                            disabledStates={[]}
                        />
                    )}
                    {selectedLeague && selectedUser && selectedCompetition && (
                        <Textarea
                            onChange={({ detail }) => {
                                // Only accept a valid finite number. Empty or garbled input would
                                // otherwise drop NaN into component state, which the backend then
                                // rejects (or worse, the submit silently ships an invalid value).
                                const n = Number(detail.value);
                                if (Number.isFinite(n)) {
                                    setPenaltyPoints(n);
                                }
                            }}
                            value={String(penaltyPoints)}
                            disableBrowserAutocorrect
                            rows={1}
                            placeholder="Add penalty points"
                        />
                    )}
                    {selectedLeague && selectedUser && selectedCompetition?.code &&
                        Number.isFinite(penaltyPoints) && penaltyPoints > 0 && (
                        <AddPenaltyButton
                            userToPenalty={selectedUser}
                            setSubmitMessage={setSubmitMessage}
                            points={penaltyPoints}
                            competitionCode={selectedCompetition.code}
                            leagueId={selectedLeague?.leagueId}
                        />
                    )}
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    )
};

export default AddPenaltyPage;